$.fn.woiMoreMenu = function (options) {

  // header-category__items
  var menuObj   = $(this);

  // header-category
  var settings = $.extend({
      moreButtonWidth : 80,
      moreButtonText  : 'more',
      sharedElement   : '',
      parentElement   : '',
      moreAction      : 'click',
  }, options );

  if (menuObj.length <= 0) return false;

  var $parentEl       = $(settings.parentElement);
  var $sharedEl       = $(settings.sharedElement);
  var initialHeight   = menuObj.height();
  var initialWidth    = ($parentEl.length == 0) ? menuObj.width() : $parentEl.width();
  var sharedWidth     = ($sharedEl.length == 0) ? 0 : $(settings.sharedElement).outerWidth(true);
  var childWidth      = 0;
  var moreMenuWidth   = initialWidth - (settings.moreButtonWidth + sharedWidth);
  var menuHtml        = '';
  menuObj.css({
    'height': initialHeight + 'px',
    'overflow': 'hidden',
    'position': 'relative',
  });

  menuObj.append($("li.hideshow > ul", menuObj).html());
  menuObj.find("li.hideshow").remove();

  menuObj.children().each(function () {
    var el = $(this);
    childWidth += el.outerWidth(true);
    if (moreMenuWidth < childWidth) {
      menuHtml += $('<div>').append(el).html();
    }
  });

  if (menuHtml != '') {
    if (settings.moreAction === 'click') {
      menuObj.append('<li class="hideshow dropdown more">' +
                        '<a href="#" class="dropdown-toggle" data-toggle="dropdown">'+ settings.moreButtonText+'</a>' +
                        '<ul class="dropdown-menu" role="menu">' + menuHtml + '</ul>' +
                      '</li>');
    } else {
      menuObj.append('<li class="hideshow dropdown more">' +
                        '<a href="#" class="morenav-hover">'+ settings.moreButtonText+'</a>' +
                        '<ul class="morenav-hover__menu">' + menuHtml + '</ul>' +
                      '</li>');

    }
  }
  menuObj.css({
    'height': '',
    'overflow': ''
  });
};
